import { Cluster, DefaultRenderer } from "@googlemaps/markerclusterer";
import { useContext, useEffect, useState } from "react";
import { AdvancedMarker, Map } from "@vis.gl/react-google-maps";
import {
  GetCompOrJuncOrAssetOrSubAndSiteNodeResult,
  GetCompOrJuncOrAssetOrSubAndSiteNodeVars,
} from "../masters/items/queries/types";

import { MapsContext } from "../maps/context/context";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../../styles/Variables";
import { useLazyQuery } from "@apollo/client";
import { JunctionOrAssetNodeById } from "../masters/items/queries/queries";
import JunctionImage from "../../../../images/ItemIcons/junction.svg";
export interface longLatPos {
  lat: number;
  lng: number;
}

type Tree = {
  key: string;
  name: string;
  lat: number;
  lng: number;
};

export class CustomRenderer extends DefaultRenderer {
  render(cluster: Cluster) {
    const count = cluster.count;
    const position = cluster.position;

    const raisedCount = cluster.markers
      ? cluster.markers.filter((m) => {
          if (
            m &&
            (m as HTMLElement).childNodes.length &&
            (m as HTMLElement).childNodes[0].childNodes.length &&
            (m as HTMLElement).childNodes[0].childNodes[0].childNodes.length
          ) {
            const element = (m as HTMLElement).childNodes[0].childNodes[0]
              .childNodes[0] as HTMLElement;

            return element.className.includes("status__open");
          } else return false;
        })
      : [];

    const bgColor = raisedCount.length > 0 ? "red" : "green";

    // Create a custom div element for the cluster
    const div = document.createElement("div");
    div.style.backgroundColor = bgColor;
    div.style.color = "white";
    div.style.borderRadius = "50%";
    div.style.width = "40px";
    div.style.height = "40px";
    div.style.display = "flex";
    div.style.alignItems = "center";
    div.style.justifyContent = "center";

    div.className =
      raisedCount.length > 0 ? "clusterer-blink" : "clusterer-unblink";
    div.innerHTML = `<strong>${count}</strong>`;

    return new google.maps.marker.AdvancedMarkerElement({
      position,
      content: div,
    });
  }
}

const AssetTypeMapView = () => {
  const { state: mapsState } = useContext(MapsContext);

  const [asset, setAsset] = useState<Tree | null>(null);
  const [GetAsset, { data }] = useLazyQuery<
    { node: GetCompOrJuncOrAssetOrSubAndSiteNodeResult },
    GetCompOrJuncOrAssetOrSubAndSiteNodeVars
  >(JunctionOrAssetNodeById);

  useEffect(() => {
    if (mapsState.assetTypeId) {
      GetAsset({
        variables: {
          id: mapsState.assetTypeId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setAsset({
            key: JSON.stringify({
              id: data.node.id,
              latitude: data.node.latitude,
              longitude: data.node.longitude,
            }),
            lat: Number(data.node.latitude),
            lng: Number(data.node.longitude),
            name: data.node.id.toString(),
          });
        }
      });
    }
  }, [mapsState.assetTypeId, GetAsset]);

  return (
    <>
      <div className="map-view">
        <Map
          defaultZoom={13}
          defaultCenter={{
            lat: asset ? asset.lat : 12.981010391578677,
            lng: asset ? asset.lng : 77.60151962452281,
          }}
          mapId={process.env.React_App_Map_ID}
          disableDefaultUI={true}
          gestureHandling={"greedy"}
        >
          {asset ? (
            <AdvancedMarker
              position={asset}
              className={`marker feature status__open`}
            >
              <CustomTooltip
                title={
                  <>
                    {data
                      ? `${data.node.name} ` +
                        `${data.node.code ? `(${data.node.code})` : ""}`
                      : ""}
                  </>
                }
                arrow
                placement="top"
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: TOOLTIP_COLORS.VARIABLE,
                      "& .MuiTooltip-arrow": {
                        color: TOOLTIP_COLORS.VARIABLE,
                      },
                    },
                  },
                }}
              >
                <img
                  src={JunctionImage}
                  className={`marker-img .status__open`}
                  alt="Image not found"
                />
              </CustomTooltip>
              <div className={`tip status__open`}></div>
            </AdvancedMarker>
          ) : null}
        </Map>
      </div>
    </>
  );
};

export default AssetTypeMapView;
